@if (label()) {
<span class="floori-label">{{ label() }}</span>
}

<div
    class="select-wrapper"
    [class.disabled]="disabled"
    [class.focused]="focused"
    [class.open]="isOpen()">
    <input
        #triggerInput
        readonly
        type="text"
        class="floori-simple-select-input"
        [value]="getSelectedOptionLabel() | flTranslate"
        [placeholder]="placeholder()"
        (focus)="focusChanged(true)"
        (blur)="handleBlur($event)"
        (click)="toggleDropdown()"
        [attr.aria-expanded]="isOpen()" />

    <div class="select-arrow" [class.open]="isOpen()">
        <floori-icon name="fl_chevron_down_o"></floori-icon>
    </div>

    @if (isOpen()) {
    <div class="dropdown-panel" (mousedown)="$event.preventDefault()">
        @for (option of options(); track option.value) {
        <div
            class="dropdown-option"
            [class.selected]="value === option.value"
            (mousedown)="selectOption(option)">
            {{ option.label | flTranslate }}
        </div>
        }
    </div>
    }
</div>
